import * as React from "react";
import {useTranslation} from "react-i18next";
import styles from "./ShoppingCart.module.scss";
import MediaQuery from "react-responsive";
import VoucherBlock from "../Rebates/VoucherBlock";

const EmptyCart: React.FC = () => {
  const {t} = useTranslation();

  return (
    <div className="center">
      <p>{t("cart.cartIsEmpty")}</p>
      <p>{t("cart.productVarietyInspiration")}</p>
      <p>
        <a className="button" href="/">
          {t("wishlist.findDesignFavourites")}
        </a>
      </p>
    </div>
  );
};

export const EmptyCartScreen: React.FC = () => {
  return (
    <div className={styles.wrapper}>
      <MediaQuery query="not all and (min-width: 768px)">
        <EmptyCart />
        <VoucherBlock />
      </MediaQuery>
      <MediaQuery query="(min-width: 768px)">
        <div className={styles.list}>
          <EmptyCart />
        </div>
        <div className={styles.details}>
          <VoucherBlock />
        </div>
      </MediaQuery>
    </div>
  );
};

export default EmptyCartScreen;
